module.exports = __webpack_public_path__ + "img/danger-kyan.6f0a7388.png";